import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { CaseStageEnum, CaseStatusEnum, SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-case-attachment-index',
    templateUrl: './case-attachment-index.component.html',
    styleUrls: ['./case-attachment-index.component.scss']
})
export class CaseAttachmentIndexComponent implements OnInit {
    @Input() eCaseId: any;
    @Input() modal: any;

    caseId: any;
    RootAttachmentArr: any;
    AttachmentIndexArr: any;
    IncommingOrgName: any;
    description: any;
    attachmentId: any;
    recordId: any;
    caseAttachmentIndexId: any;
    fileName: any;
    attachmentTypeName: any;
    doc: any = "";
    pdfFile = false;
    image: any;
    caseStatusId: any;
    CaseDetails: any;
    stageId: any;
    attachmentTypeId: any;
    CheckAttachment: any;
    isCheckAttachment: any = 0;
    MassageResponse: string;
    showAssignResponse: boolean = false;
    constructor(public route: Router, private sanitizer: DomSanitizer, private dateformat: DateFormatterService, private modalService: NgbModal, public sharedService: SharedHttpService, public caseService: CaseService, private lookupService: LookupService, private toastr: NotificationService) { }
    public caseStatusEnum = CaseStatusEnum;
    public caseStageEnum = CaseStageEnum;

    ngOnInit(): void {
        this.caseId = this.caseService.case.caseId;
        this.caseStatusId = this.caseService.case.caseStatusId;
        this.stageId = this.caseService.case.stageId;
        this.CaseDetails = this.caseService.case;

        this.loadDate();
    }
    loadDate() {
        this.sharedService.get(`api/CaseAttachmentIndex/GetRootAttachment?eCaseId=${this.eCaseId}`).subscribe(res => {
            this.RootAttachmentArr = res;
        });
        this.sharedService.get(`api/CaseAttachmentIndex/GetCaseIndex?eCaseId=${this.eCaseId}`).subscribe(res => {
            this.AttachmentIndexArr = res;
        })
        //this.sharedService.get(`api/Case/GetCaseTypeAttachmentTypes?eCaseId=${this.eCaseId}`).subscribe(res=>{
        //  this.CheckAttachment=res;
        // console.log(this.CheckAttachment)
        //this.CheckAttachment.forEach(element => {
        // if(element.isAddedToIndex==true)
        //   {
        //     this.isCheckAttachment++;
        //   }
        //   else{
        //     this.isCheckAttachment--;
        //   }
        //console.log(this.isCheckAttachment)

        //});


        // });
    }
    EditAttachment(att, editAttachment) {
        if (att.incommingOrgName == "undefined")
            this.IncommingOrgName = "";
        else
            this.IncommingOrgName = att.incommingOrgName;

        if (att.description == "undefined")
            this.description = "";
        else
            this.description = att.description;

        this.attachmentId = att.attachmentId;
        this.recordId = att.recordId;
        this.fileName = att.fileName;
        this.recordId = att.recordId;
        this.attachmentTypeName = att.attachmentTypeName;
        this.attachmentTypeId = att.attachmentTypeId;

        this.sharedService.openSmall(editAttachment);
    }


    onAddAttach(modal) {
        let url = 'api/CaseAttachmentIndex/Insert';
        let objectAdded = {
            "caseId": this.caseId,
            "attachmentId": this.attachmentId,
            "recordId": this.recordId,
            "incommingOrgName": this.IncommingOrgName,
            "description": this.description,
            "fileName": this.fileName,
            "attachmentTypeName": this.attachmentTypeName,

            "attachmentTypeId": this.attachmentTypeId,
            //  "attachmentTypeName": "string",
            // "elementTypeName": "string"

        };

        this.sharedService.post(url, [objectAdded]).subscribe(
            (response) => {
                modal.dismiss('Cross click');
                this.loadDate();
                this.sharedService.showSuccessKey("SavedSuccessfully");
            },
        );
    }

    sendIndex(caseAttachmentIndexId) {
        this.sharedService.get(`api/Case/SendIndex?IndexId=${caseAttachmentIndexId}`).subscribe(res => {

            if (res.isSucess === true) {

                this.sharedService.get(`api/CaseAttachmentIndex/GetCaseIndex?eCaseId=${this.eCaseId}`).subscribe(res2 => {
                    this.AttachmentIndexArr = res2;
                    this.toastr.showSuccess(res.message, '');

                });





            } else {
                this.toastr.showError(res.message, '');
            }

        });
    }

    sendCaseToProsecution(eCaseId) {
        this.sharedService.get(`api/Case/SendCaseToProsecution?eCaseId=${eCaseId}`).subscribe(res => {

            if (res.isSucess === true) {

                this.toastr.showSuccess(res.message, '');

                this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
                    this.route.navigate([`details/case/${this.eCaseId}/cases`]);
                });
            } else {
                this.toastr.showError(res.message, '');
            }
            this.modal.dismiss('Cross click');

        });
    }
    downloadFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.fileType });
        var url = window.URL.createObjectURL(blob);

        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = attachment.fileName;
        fileLink.click();
    }
    download(attachment) {
        let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.downloadFile(data, attachment);
        });
    }
    previewPDF(attach, pdfmodal) {
        this.sharedService.openLarge(pdfmodal);
        this.show(attach);
    }
    show(attachment) {
        let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.ShowFile(data, attachment);
        });
    }
    ShowFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.fileType });
        var url = window.URL.createObjectURL(blob);
        this.doc = url;
        if (attachment.fileName.endsWith('.pdf')) {
            this.pdfFile = true;

        } else {
            this.pdfFile = false;
            this.image = this.sanitizer.bypassSecurityTrustUrl(url);
        }
    }


    DeletePhisicalAttachment(caseAttachmentIndexId, modal) {
        this.caseAttachmentIndexId = caseAttachmentIndexId;
        this.sharedService.openSmall(modal);
    }
    onDeletePhisicalAttach(modal) {
        let url = `api/CaseAttachmentIndex/Delete`;
        this.sharedService.delete(url, [this.caseAttachmentIndexId]).subscribe(res => {
            modal.dismiss('Cross click');
            this.loadDate();
            if (res.length > 0)
                this.sharedService.showSuccessKey("DeletedSuccessfully");
            else
                this.sharedService.showErrorKey("ThisActionIsNotAllowed");
        });
    }
    detailsMassage(item, modal) {
        this.showAssignResponse = false;

        if (item.response != null) {
            if (item.response.indexOf("request entity is too large") != -1) {
                this.MassageResponse = item.response + "\n" + "";
                this.showAssignResponse = false;
            }
            if (item.response.indexOf("connect to the back-end") != -1) {
                this.MassageResponse = item.response  ;
                this.showAssignResponse = true;
            }
            if (item.response.indexOf("Object reference not set to an instance of an object.") != -1) {
                this.MassageResponse = item.response;
                this.showAssignResponse = true;
            }
            if (item.response.indexOf("502 Bad Gateway") != -1) {
                this.MassageResponse = item.response;
                this.showAssignResponse = true;
            }
            if (item.response.indexOf("Your support ID is") != -1) {
                this.MassageResponse = item.response;
                this.showAssignResponse = true;
            }

            if (item.response.indexOf('ER0000') != -1 && item.response.indexOf('ReceptionCode') != -1) {
                this.MassageResponse = item.response;
                this.showAssignResponse = true;
            }


        }
        this.sharedService.openSmall(modal);

    }
}

